export default __webpack_public_path__ + "static/media/dislike.19dc9318.svg";